import {call, put, takeLatest} from 'redux-saga/effects';
import Api, {ApiMethods} from 'feedback-system/middleware/api';
import {GET_USERS_ACTION, ADD_ROLE_ACTION, DELETE_ROLE_ACTION} from './constants';
import {
    fetchUsersRequest,
    fetchUsersSuccess,
    fetchUsersError,
    addRoleRequest,
    addRoleSuccess,
    addRoleError,
    deleteRoleRequest,
    deleteRoleSuccess,
    deleteRoleError
} from './actions';
import {IAction} from '../types';

export function* fetchUsers() {
    yield put(fetchUsersRequest());

    try {
        const data = yield call(Api.fetch, {
            endpoint: 'profiles/all',
            method: ApiMethods.GET
        });

        yield put(fetchUsersSuccess(data.responseData));
    } catch (error) {
        yield put(fetchUsersError(error.message));
    }
}

export function* fetchUsersSaga() {
    yield takeLatest(GET_USERS_ACTION, fetchUsers);
}

function* addRole(action: IAction) {
    yield put(addRoleRequest());

    try {
        yield call(Api.fetch, {
            endpoint: `profiles/role?id=${action.user.id}&role=${action.user.role}`,
            method: ApiMethods.POST
        });

        yield put(addRoleSuccess());
    } catch (error) {
        yield put(addRoleError(error.message));
    }
}

export function* addRoleSaga() {
    yield takeLatest(ADD_ROLE_ACTION, addRole);
}

function* deleteRole(action: IAction) {
    yield put(deleteRoleRequest());

    try {
        yield call(Api.fetch, {
            endpoint: `profiles/role?id=${action.user.id}&role=${action.user.role}`,
            method: ApiMethods.DELETE

        });

        yield put(deleteRoleSuccess());
    } catch (error) {
        yield put(deleteRoleError(error.message));
    }
}

export function* deleteRoleSaga() {
    yield takeLatest(DELETE_ROLE_ACTION, deleteRole);
}
